module.exports = __webpack_public_path__ + "media/images/iconDelete--dark-c38692d5f115974ac490680ff5dfc639.png";